import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <FeaturesSection />
        <MediaSection />
        <CarouselSection />
        <RankingSection />
        <AppSection />
        <CardsSection />
        <TopicsSection />
        <CommentsSection />
        <UpdatesSection />
        <ContactSection />
        <IndexSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}